function init() {
	if($("#free-detector-container").length > 0){
		$(".btn-step-1").unbind("click");
		$(".btn-step-1").bind("click",function(){
			$("#free-detector-step1-container").fadeOut("fast",function(){
				$("#free-detector-step2-container").fadeIn("fast");
			});
			
			$("#next-previous-step1-mobile").fadeOut("fast");
			
			$('html, body').animate({
				scrollTop: $(".free-detector-header:first").height()
			 }, 800);
		});
		
		$(".btn-prev").unbind("click");
		$(".btn-prev").bind("click",function(){
			$("#free-detector-step2-container").fadeOut("fast",function(){
				$("#free-detector-step1-container").fadeIn("fast");
			});
			
			$("#next-previous-step1-mobile").fadeIn("fast");
		});
		
		$('input[type=radio][name=HasCode]').change(function() {
			if (this.value == 'true') {
				$(".form-code-input").show();
			}
			else if (this.value == 'false') {
				$(".form-code-input").hide();
			}
		});
		
		$(".btn-submit-free-detector-form").unbind("click");
		$(".btn-submit-free-detector-form").bind("click",function(e) {
			var form =  $("#free-detector-form");
			var alert = form.find(".alert:first");
			alert.html("");
			alert.addClass("hide");
			
			$.ajax({
			   type: "POST",
			   url: form.attr("action"),
			   data: form.serialize(), 
			   success: function(data)
			   {
					if(!data.success){
						for(var i = 0; i < data.errors.length; i++){
						   alert.append("<p>&#x2022; " + data.errors[i] + "</p>")
						}
					   
						alert.removeClass("hide");
					}else{
						alert.addClass("hide");
						window.location.href = data.data;
					} 
			   }
			 });
			
			e.preventDefault();
		});
	}
}

module.exports = {
	init : init
}